import React, { useEffect, useState } from 'react';
import PolicyAnalyzeCardSty from './PolicyAnalyzeCard.module.css';
import {getPolicyCate, getPolicyConsult} from "../../components/AboutPolicy/service";
import ellipsisContent from "../../utils/EllipsisContent";
import {withRouter} from "react-router";

let policyCate;

const PolicyAnalyzeCard = (props) => {
    const { history } = props;
    const [policyConsultData, setPolicyConsultData] = useState([]);

    useEffect(() => {
        (async () => {
            const policyConsult = await getPolicyConsult();
            policyCate = (await getPolicyCate()).data.list;
            setPolicyConsultData(policyConsult.data.list)
        })()
    }, []);

    const typeDict = {1: '#367AFF', 2: '#FEB34D', 3:'#1FC0AB', 4: '#367AFF', 5: '#FEB34D'};

    const onMoreClick = item => {
        window.scrollTo(0,400);
        history.push(`/policy/more/${item[0].id}/${item[0].title}`);
    };

    const onPolicyAnalyzeCardItemClick = item => {
        const { cate_id, cate_desc, id} = item;
        window.scrollTo(0,400);
        history.push(`/policy/more/${cate_id}/${cate_desc}/detail/${id}`);
    };

    const policyInfoLis = policyConsultData.map((item) => {
        const { id, title, content, cover_link, cate_id, cate_desc } = item;
        if(!cate_desc.includes('专题')){
            return(
                <li key={id} onClick={() => {onPolicyAnalyzeCardItemClick(item)}}>
                    <div className={PolicyAnalyzeCardSty.li_imgDiv} style={{backgroundImage:`url(${cover_link})`}}/>
                    <div className={PolicyAnalyzeCardSty.li_titleDiv}>
                        <div className={PolicyAnalyzeCardSty.li_typeSty} style={{color: typeDict[cate_id]}}>【{cate_desc.slice(0,2)}】</div>
                        <div className={PolicyAnalyzeCardSty.li_titleSty}>{title}</div>
                    </div>
                    <div className={PolicyAnalyzeCardSty.li_descriptionSty}>
                        { ellipsisContent(content) }
                    </div>
                </li>
            );
        }
    });

    return(
        <div className={`${PolicyAnalyzeCardSty.lineDiv}`}>
            <div className={PolicyAnalyzeCardSty.title}>
                政策咨询
                <span className={PolicyAnalyzeCardSty.moreButton} onClick={() => {onMoreClick(policyCate)}}>更多 >></span>
            </div>
            <ul>
                {policyInfoLis}
            </ul>
        </div>
    );
};

export default withRouter(PolicyAnalyzeCard);
